module.exports = __webpack_public_path__ + "static/media/sanity.52b1f323.png";